import PropTypes from "prop-types";

import { alignItems } from "../../consts";

import SVG from "../SVG/icons";
import FlexContainers from "../Containers/FlexContainers";
import { Paragraph2 } from "../Text/Paragraphs";
import WrapperContainer from "../Containers/WrapperContainer";
import { NoteStyled } from "./styled";

const Note = ({ children }) => {
  return (
    <NoteStyled Container={FlexContainers.FlexRowStart} alignItems={alignItems.start} gap={12}>
      <WrapperContainer width={15} height={15} pt={3}>
        <SVG.InfoIcon />
      </WrapperContainer>
      <Paragraph2>{children}</Paragraph2>
    </NoteStyled>
  );
};

Note.propTypes = {
  children: PropTypes.string.isRequired
};

export default Note;
